export default {
  login: "登录",
  myData: "我的数据",
  publishData: "发布数据",
  userInfo: "个人信息",
  dataSeller: "数据卖家",
  review: "我的审核",
  myWallet: "我的钱包",
  myTrade: "销售订单",
  openPersonalAccount: "开通个人账户",
  myMessage: "我的消息",
  dataDetailTitle: "数据详情",
  dataBuyer: "数据买家",
  myOrder: "我的订单",
  myReport: "我的报告",
  myApi: "我的API",
  logOut: "退出登录",
  document: "文档",
  message: "消息",
  welcome: "欢迎页",
  community: "有求必应",
};
